import { combineEpics, createEpicMiddleware, Epic, EpicMiddleware } from 'redux-observable'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { mergeMap } from 'rxjs/operators'

export interface EpicsModule {
  middleware: EpicMiddleware<any, any, any>
  providers: { [key: string]: any }
  inject(epic: Epic<any, any> | Array<Epic<any, any>>, newProvidersMap?: {}): void
}

const isArray = Array.isArray
const providers = {}

// tslint:disable-next-line:prefer-object-spread
const registerProvider = (newProviders: {}) => Object.assign(providers, newProviders)

export const createInjectableEpics = (initialEpics: Array<Epic<any, any>>, initialProviders: {}): EpicsModule => {
  const inject = (epic: Epic<any, any> | Array<Epic<any, any>>, newProvidersMap?: {}) => {
    newProvidersMap && registerProvider(newProvidersMap)
    if (isArray(epic)) {
      epic.forEach((e) => epic$.next(e))
    } else {
      epic$.next(epic)
    }
  }

  const epic$ = new BehaviorSubject(combineEpics(...initialEpics))

  const rootEpic: Epic<any, any> = (action$, store) => epic$.pipe(mergeMap((epic) => epic(action$, store, providers)))

  const epicMiddleware = createEpicMiddleware(rootEpic, { dependencies: registerProvider(initialProviders) })

  return {
    inject,
    middleware: epicMiddleware,
    providers,
  }
}



// WEBPACK FOOTER //
// ./src/modules/store/create-async-epic.ts